module.exports = __webpack_public_path__ + "static/media/icon-arrow-right-white.2adc3903.webp";